export default __webpack_public_path__ + "static/6367552a578f8ad89d2fc94b4eca5025.jpeg";